import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import {
  fetchOrganizationUsers,
} from '../../SetupActions';
import UserTable from '../../components/UserTable/UserTable';

import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';

class UserSettingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.syncUsers = this.syncUsers.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  syncUsers(params) {
    const { organization } = this.props;
    return this.props.dispatch(fetchOrganizationUsers(organization._id, { ...params, withEmailSignatures: false }));
  }

  render() {
    const { organization } = this.props;
    const isDemo = organization && organization.is_demo;

    return (
      <div>
        <Helmet title="Feedback Request Users Settings | Organization Setup" />
        <div className="well">
          Enable feedback request features by user.
        </div>
        {isDemo &&
          <div className="alert alert-warning">
            You cannot change this setting in a demo organization.
          </div>
        }
        {!isDemo &&
          <div>
            <UserTable
              key={organization._id}
              showOrganizationDetailColumn={false}
              showEmailColumn={false}
              organization={organization}
              toggleSelect={this.handleToggleSelect}
              fetchAction={this.syncUsers}
              canAddUser={false}
              statusFilter
              showEmailSignatures
              hideActionColumn
              showFeedbackRequestControl
            />
          </div>
        }
      </div>
    );
  }
}



// Retrieve data from store as props
function mapStateToProps(state) {
  const organization = getUserCurrentOrganization(state);
  return {
    organization,
  };
}

UserSettingPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
};
UserSettingPage.defaultProps = {
  
};
UserSettingPage.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};


export default connect(mapStateToProps)(UserSettingPage);
